/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NodataDiscardBillResVo
 */
export interface NodataDiscardBillResVo {
    /**
     * 账单ID
     * @type {number}
     * @memberof NodataDiscardBillResVo
     */
    billId?: number;
    /**
     * 账单总金额
     * @type {number}
     * @memberof NodataDiscardBillResVo
     */
    totalAmount?: number;
    /**
     * 货币代码，如 KRW
     * @type {string}
     * @memberof NodataDiscardBillResVo
     */
    currencyCode?: string;
    /**
     * 账单原始状态（BillStatusEnum）
     * @type {number}
     * @memberof NodataDiscardBillResVo
     */
    billStatus?: number;
    /**
     * 费用类型名称（BillTypeEnum.NO_DATA_DISPOSAL_FEE，中/韩）
     * @type {string}
     * @memberof NodataDiscardBillResVo
     */
    feeTypeName?: string;
    /**
     * 支付状态名称（中/韩，如 待支付/已支付）
     * @type {string}
     * @memberof NodataDiscardBillResVo
     */
    payStatusName?: string;
    /**
     * 是否已支付（前端可据此区分样式）
     * @type {boolean}
     * @memberof NodataDiscardBillResVo
     */
    paid?: boolean;
}

/**
 * Check if a given object implements the NodataDiscardBillResVo interface.
 */
export function instanceOfNodataDiscardBillResVo(value: object): value is NodataDiscardBillResVo {
    return true;
}

export function NodataDiscardBillResVoFromJSON(json: any): NodataDiscardBillResVo {
    return NodataDiscardBillResVoFromJSONTyped(json, false);
}

export function NodataDiscardBillResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NodataDiscardBillResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'billId': json['billId'] == null ? undefined : json['billId'],
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'billStatus': json['billStatus'] == null ? undefined : json['billStatus'],
        'feeTypeName': json['feeTypeName'] == null ? undefined : json['feeTypeName'],
        'payStatusName': json['payStatusName'] == null ? undefined : json['payStatusName'],
        'paid': json['paid'] == null ? undefined : json['paid'],
    };
}

export function NodataDiscardBillResVoToJSON(json: any): NodataDiscardBillResVo {
    return NodataDiscardBillResVoToJSONTyped(json, false);
}

export function NodataDiscardBillResVoToJSONTyped(value?: NodataDiscardBillResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billId': value['billId'],
        'totalAmount': value['totalAmount'],
        'currencyCode': value['currencyCode'],
        'billStatus': value['billStatus'],
        'feeTypeName': value['feeTypeName'],
        'payStatusName': value['payStatusName'],
        'paid': value['paid'],
    };
}

